<div class="tire-add-new-dialog">
  <div class="tire-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire font-20 font-gray-45 header-icon font-white"></i>
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14 font-white" *ngIf="!tireId">
            Add new tire
          </p>
          <p class="m-0 font-secondary-700 font-14 font-white" *ngIf="tireId">
            {{ tire?.brand?.name }} - {{ tire?.model }}
          </p>
        </div>

        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>
  <div class="tire-modal-wrapper">
    <!-- Start Add Tire Body -->
    <div class="ui-12-g tire-body p-0 border-bottom-light">
      <div class="row tire-body-row m-0 p-0">
        <!-- Column 3: List of Items -->
        <div class="col-3 tire-navigation pl-0 pr-1">
          <ul>
            <li *ngFor="let section of sections; let i = index" [class.active]="selectedTab === 0 && activeIndex === i"
              (click)="scrollToContent(i)">
              {{ section.title }}
            </li>

            <li (click)="onTabSelect(1)" class="flex-between-center mt-2" [ngClass]="selectedTab === 1 && 'active'">
              <div>
                Activity logs
              </div>
              <div>
                <i class="fas fa-chevron-right font-secondary"></i>
              </div>
            </li>
          </ul>
        </div>

        <!-- Column 9: Content Divs -->
        <div class="col-9 tire-navigation-content p-0 m-0 mt-1" (scroll)="onScroll($event,'20')" #contentContainer>
          <div class="scroll-wrapper" *ngFor="let tireSize of tire.sizes">
            <div class="scroll-wrapper-inner" [hidden]="selectedTab === 1">
              <div class="sections-wrapper" *ngFor="let section of sections; let i = index" [id]="'content-' + i">
                <div>
                  <span class="font-18 font-700">{{ section.title }}</span>
                  <span class="ml-2" *ngIf="section.title === 'Pricing'"><i tooltipPosition="top"
                      tooltipStyleClass="motor-vehicle-link-tooltip font-12" [pTooltip]="tooltip"
                      class="far fa-sack-dollar stack-icon pointer font-gray-55"
                      [ngClass]="{'stack-icon': tooltip}"></i></span>
                </div>

                <!-- Basic info -->
                <div *ngIf="section.title === 'Basic Information'">
                  <div class="row input-control-container">
                    <div class="col-6 flex-start-center input-col">

                      <div class="w-70p">
                        <label for="tire-size">Part Number</label>
                        <app-input id="tire-size" placeholder="Enter part number" theme="border"
                          [value]="tire?.tireExternalId" [autoFocus]="tireExternalId"
                          (appFocus)="handleFocus('tireExternalId')" (appBlur)="handleBlur('tireExternalId')"
                          (appChange)="handleChange($event, 'tireExternalId')">
                        </app-input>
                      </div>
                      <div class="w-25p top-32p ml-2">
                        <button *ngIf="!partSearchResults.length" id="part-cancel-btn"
                          [ngClass]="{ 'disabled': !isTireConnectConnected || !tire?.tireExternalId  }"
                          [disabled]="isProcessingResults" class="btn btn-border btn-magic pointer btn-submit mr-1"
                          (click)="showPartSuggestionContainer('magic')">
                          <i class="fal fa-magic" *ngIf="!isProcessingResults"></i>
                          <i class="fa fa-spinner rotate" *ngIf="isProcessingResults"></i>
                          <span class="ml-1">Magic Fill</span>
                        </button>

                        <button *ngIf="partSearchResults.length" id="part-cancel-btn"
                          [ngClass]="{ 'disabled': !isTireConnectConnected || !tire?.tireExternalId  }"
                          [disabled]="isProcessingResults" class="btn btn-border btn-magic pointer btn-submit mr-1"
                          (click)="showPartSuggestionContainer('clear')">
                          <i class="fal fa-undo" *ngIf="!isProcessingResults"></i>
                          <i class="fa fa-spinner rotate" *ngIf="isProcessingResults"></i>
                          <span class="ml-1">Clear All</span>
                        </button>
                      </div>

                      <div *ngIf="isShowPartSuggestions && partstechSuggestions.length">
                        <span class="dropdown-menu-arrow"></span>
                        <ul class="parts-suggesion p-0 ">
                          <div *ngFor="let partstechSuggestion of partstechSuggestions; let index = index"
                            (click)="setAutofillFields(partstechSuggestion, 'select')"
                            (mouseenter)="setAutofillFields(partstechSuggestion,'hover')"
                            (mouseleave)="clearAutofillFields()">
                            <li class="m-1 pl-2 parts-suggesion-list-item">
                              <div class="fon-13 font-700 font-gray-700 capitalize">{{partstechSuggestion?.model}}</div>

                              <div class="flex-between-center mt-1">
                                <div class="flex-column">
                                  <div class="fon-12 font-400 font-gray-600">{{partstechSuggestion?.size}}</div>
                                  <div class="fon-12 font-400 font-gray-600">{{partstechSuggestion?.brand}}</div>
                                </div>
                                <div class="flex-column">
                                  <div class="fon-12 font-400 font-gray-600">{{partstechSuggestion?.season}}</div>
                                  <div class="fon-12 font-400 font-gray-600">{{partstechSuggestion?.tire_type}}</div>
                                </div>
                              </div>

                              <!-- <div class="fon-12 font-400 font-gray-600">Autozone</div> -->
                            </li>
                          </div>
                        </ul>
                      </div>
                    </div>

                    <div class="col-6 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p" [ngClass]="{ 'magic-focus': isMagicFocus }">
                        <label for="tire-brand">Brand*</label>
                        <app-auto-complete id="tire-brand" listId="tire-brand-list" placeholder="Brand"
                          [autoFocus]="focus?.brand" field="brandName" scrollHeight="186px" theme="border"
                          editFieldLabel="Create brand" editableItemIdKey="categoryId"
                          editFieldPlaceholder="Create brand" [disabled]="isPartsTechItem" [isInvalid]="errors?.brand"
                          [errorMessage]="errors?.brand" [hasEditableField]="false"
                          [hasEditableField]="!isNewCategoriesEnabled" [isLoading]="isBrandLoading"
                          [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
                          [hasStaticUnassignedFiled]="false" [suggestions]="brands" [listItemFontSize]="14"
                          [value]="tire?.brand?.name" [fontSize]="14" [isSaveForFuture]="true"
                          [isClearIconVisible]="tire?.brand?.name" (appSelect)="handleSelect($event, 'brand')"
                          (appCompletedMethod)="handleTagSearch($event)" (appUpdateItem)="onUpdateItem($event, 'brand')"
                          (appClickOutside)="focus.brand = false" (appSave)="handleCreateBrand($event)"
                          (appClear)="handleClear('brand')" (scroll)="handleScroll()" (appFocus)="handleFocus('brand')">
                          <ng-template let-item let-editItem="editItem" appTemplate="item">
                            <div class="tag-item flex-between-center">
                              <div>
                                <span>{{ item?.name }}</span>
                              </div>
                              <div class="tag-item-action flex-end-center">
                                <i *ngIf="!isNewCategoriesEnabled" class="fas fa-pencil p-1 mr-2"
                                  (click)="$event.stopPropagation(); editItem(item)"></i>
                              </div>
                            </div>
                          </ng-template>
                        </app-auto-complete>
                        <!-- [suggestions]="tagsSuggestion" [hasEditableField]="!isNewCategoriesEnabled" -->
                      </div>
                    </div>
                  </div>

                  <!-- size and tire name line -->
                  <div class="row input-control-container">
                    <div class="col-6 flex-start-center input-col">
                      <!-- Model -->
                      <div class="tire-category width-100p" [ngClass]="{ 'magic-focus': isMagicFocus }">
                        <label for="tire-brand">Model*</label>
                        <app-input id="tire-size" placeholder="Enter model" [disabled]="isPartsTechItem" theme="border"
                          [value]="tire?.model" [autoFocus]="false" [isInvalid]="errors.model"
                          [errorMessage]="errors.model" (appFocus)="handleFocus('model')"
                          (appBlur)="handleBlur('model')" (appChange)="handleChange($event, 'model')">
                        </app-input>
                      </div>
                    </div>

                    <!-- Tire name -->
                    <div class="col-6 flex-start-center input-col">
                      <div class="tire-category width-100p">
                        <div class="label-custom-size-dropdown-wrapper">
                          <div class="label-custom-size mr-2">
                            <label for="tire-brand">Width*</label>
                          </div>
                          <div class="label-custom-size mr-2">
                            <label for="tire-brand" class="ml-2">Aspect Ratio*</label>
                          </div>
                          <div class="label-custom-size mr-2">
                            <label for="tire-brand" class="ml-2">Rim Diameter*</label>
                          </div>
                        </div>

                        <!-- <label for="tire-brand">Size*</label> -->
                        <div class="custom-size-dropdown-wrapper">
                          <div class="custom-size mr-2" [ngClass]="{ 'magic-focus': isMagicFocus }">
                            <app-input placeholder="Enter width" [disabled]="isPartsTechItem" theme="border"
                              [isInvalid]="errors?.tireWidth" [errorMessage]="errors.tireWidth" [allowDecimal]="true"
                              [value]="tire?.tireWidth" [selectTextOnFocus]="true" [autoFocus]="focus?.tireWidth"
                              (appChange)="handleSizeSelectQTQ('tireWidth',$event)">
                            </app-input>
                          </div>
                          <span class="mr-2 border-left size-separator"></span>
                          <div class="custom-size mr-2" [ngClass]="{ 'magic-focus': isMagicFocus }">
                            <app-input placeholder="Enter profile" [disabled]="isPartsTechItem" theme="border"
                              [isInvalid]="errors?.tireProfile" [selectTextOnFocus]="true" [allowDecimal]="true"
                              [errorMessage]="errors.tireProfile" [value]="tire?.tireProfile"
                              [autoFocus]="focus?.tireProfile" (appChange)="handleSizeSelectQTQ('tireProfile', $event)">
                            </app-input>
                          </div>
                          <span class="mr-2 border-left size-separator"></span>
                          <div class="custom-size" [ngClass]="{ 'magic-focus': isMagicFocus }">
                            <app-input placeholder="Enter size" [disabled]="isPartsTechItem" theme="border"
                              [isInvalid]="errors?.tireSize" [errorMessage]="errors.tireSize" [allowDecimal]="true"
                              [autoFocus]="focus?.tireSize" [value]="tire?.tireSize" [selectTextOnFocus]="true"
                              (appChange)="handleSizeSelectQTQ('tireSize', $event)">
                            </app-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- size and tire name line end -->


                  <!-- part number and manufecture number start-->
                  <div *ngIf="companyLocalization else nameLocalizationFlag">
                    <div class="row input-control-container d-flex"
                      [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
                      <!-- supplier -->
                      <div class="col-6 flex-start-center input-col">
                        <div class="width-100p" [ngClass]="{ 'magic-focus': tireSize?.title && isMagicFocus }">
                          <label for="tire-number">Tire Display Name (EN){{ currentLang === 'en'? '*' : ''}}</label>
                          <app-input id="tire-name" placeholder="Enter tire name (EN)" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.title" [errorMessage]="errors.title"
                            [value]="tireSize?.title" [autoFocus]="false" (appBlur)="handleBlur('title')"
                            (appChange)="handleSizeChange('title',$event)" (appFocus)="handleFocus('title')">
                          </app-input>
                        </div>
                      </div>

                      <div class="col-6 flex-start-center input-col">
                        <div class="width-100p" [ngClass]="{ 'magic-focus': tireSize?.titleFR && isMagicFocus }">
                          <label for="tire-number">Tire Display Name (FR){{ currentLang === 'fr'? '*' : ''}}</label>
                          <app-input id="tire-name" placeholder="Enter tire name (FR)" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.titleFR" [errorMessage]="errors.titleFR"
                            [value]="tireSize?.titleFR" [autoFocus]="false" (appBlur)="handleBlur('titleFR')"
                            (appChange)="handleSizeChange('titleFR',$event)" (appFocus)="handleFocus('titleFR')">
                          </app-input>
                        </div>
                      </div>

                    </div>

                    <div class="row input-control-container d-flex">
                      <div class="col-6 flex-start-center input-col">
                        <div class="tire-category width-100p"
                          [ngClass]="{ 'magic-focus': tireSize.size && isMagicFocus }">
                          <label for="tire-size" class="font-16 font-600">Raw Tire Size</label>
                          <app-input id="tire-size" placeholder="Enter raw tire size" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.size" [autoFocus]="focus?.size" [value]="tireSize.size"
                            (appChange)="handleSizeChange('size', $event)" (appFocus)="handleFocus('size')"
                            (appBlur)="handleBlur('size')">
                          </app-input>
                        </div>
                      </div>

                      <!-- <div class="col-6 view-more-section mb-0 align-items-center d-flex" *ngIf="isExpanded">
                        <div class="view-more-cc" (click)="toggleRowExpansion()">
                          Show more
                          <span></span>
                          <i class="far fa-chevron-down"></i>
                        </div>
                      </div> -->
                    </div>
                    <!-- part number and manufecture number start-->
                  </div>

                  <ng-template #nameLocalizationFlag>
                    <!-- part number and manufecture number start-->
                    <div class="row input-control-container">
                      <!-- supplier -->
                      <div class="col-6 flex-start-center input-col">
                        <div class="width-100p" [ngClass]="{ 'magic-focus': tireSize?.title && isMagicFocus }">
                          <label for="tire-number">Tire Display Name*</label>
                          <app-input id="tire-name" placeholder="Enter tire name" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.title" [errorMessage]="errors.title"
                            [value]="tireSize?.title" [autoFocus]="false" (appBlur)="handleBlur('title')"
                            (appChange)="handleSizeChange('title',$event)" (appFocus)="handleFocus('title')">
                          </app-input>
                        </div>
                      </div>

                      <div class="col-6 flex-start-center input-col">
                        <div class="tire-category width-100p"
                          [ngClass]="{ 'magic-focus': tireSize.size && isMagicFocus }">
                          <label for="tire-size" class="font-16 font-600">Raw Tire Size</label>
                          <app-input id="tire-size" placeholder="Enter raw tire size" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.size" [autoFocus]="focus?.size" [value]="tireSize.size"
                            (appChange)="handleSizeChange('size', $event)" (appFocus)="handleFocus('size')"
                            (appBlur)="handleBlur('size')">
                          </app-input>
                        </div>
                      </div>

                      <!-- <div class="col-6 mt-3 view-more-section mb-0 align-items-center d-flex" *ngIf="isExpanded">
                        <div class="view-more-cc" (click)="toggleRowExpansion()">
                          Show more
                          <span></span>
                          <i class="far fa-chevron-down"></i>
                        </div>
                      </div> -->

                    </div>
                  </ng-template>


                  <div class="w-100 border-bottom-light mt-3"></div>
                  <div class="row input-control-container mt-3">
                    <div class="font-18 font-700 col-12">Additional Information</div>
                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.loadIndex && isMagicFocus }">
                        <label for="load-index">Load Index</label>
                        <app-input id="load-index" placeholder="Enter load index" theme="border"
                          [value]="tire?.loadIndex" (appBlur)="handleBlur('loadIndex')"
                          (appChange)="handleChange($event, 'loadIndex')" (appFocus)="handleFocus('loadIndex')">
                        </app-input>
                      </div>
                    </div>

                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.loadIndexDual && isMagicFocus }">
                        <label for="tire-number">Load Index Dual</label>
                        <app-input id="tire-name" placeholder="Enter load index dual" theme="border"
                          [value]="tire?.loadIndexDual" (appBlur)="handleBlur('loadIndexDual')"
                          (appChange)="handleChange($event, 'loadIndexDual')" (appFocus)="handleFocus('loadIndexDual')">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.speedRating && isMagicFocus }">
                        <label for="tire-number">Speed Rating</label>
                        <app-input id="tire-name" placeholder="Enter speed rating" theme="border"
                          [value]="tire?.speedRating" (appBlur)="handleBlur('speedRating')"
                          (appChange)="handleChange($event, 'speedRating')" (appFocus)="handleFocus('speedRating')">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.loadRange && isMagicFocus }">
                        <label for="tire-number">Load Range</label>
                        <app-input id="tire-name" placeholder="Enter load range" theme="border"
                          [value]="tire?.loadRange" (appBlur)="handleBlur('loadRange')"
                          (appChange)="handleChange($event,'loadRange')" (appFocus)="handleFocus('loadRange')">
                        </app-input>
                      </div>
                    </div>

                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.sideWallStyle && isMagicFocus }">
                        <label for="tire-number">Sidewall Style</label>
                        <app-input id="tire-name" placeholder="Enter sidewall style" theme="border"
                          [value]="tire?.sideWallStyle" (appBlur)="handleBlur('sideWallStyle')"
                          (appChange)="handleChange($event,'sideWallStyle')" (appFocus)="handleFocus('sideWallStyle')">
                        </app-input>
                      </div>
                    </div>

                    <div class="col-3 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.utqg && isMagicFocus }">
                        <label for="tire-number">UTQG</label>
                        <app-input id="tire-name" placeholder="Enter UTQG" theme="border" [value]="tire?.utqg"
                          (appBlur)="handleBlur('utqg')" (appChange)="handleChange($event,'utqg')"
                          styleClassInput="textutqg" (appFocus)="handleFocus('utqg')">
                        </app-input>
                      </div>
                    </div>

                    <div class="col-6 flex-start-center input-col mt-3">
                      <div class="width-100p" [ngClass]="{ 'magic-focus': tire?.mileageRating && isMagicFocus }">
                        <label for="tire-warranty">Warranty</label>
                        <app-input id="tire-name" theme="border" [maxLength]="6" [value]="tire?.mileageRating"
                          placeholder="Enter warranty" (appBlur)="handleBlur('mileageRating')"
                          (appChange)="handleChange($event, 'mileageRating')" buttonLabel="miles"
                          styleClassButton="tire-utqg" styleClassInput="width-52px" [hasShowButton]="true"
                          (appFocus)="handleFocus('mileageRating')">
                        </app-input>
                      </div>
                    </div>

                  </div>

                  <!-- <div class="mb-0 p-0 row view-more-section mt-3 pl-3" *ngIf="!isExpanded">
                    <div class="view-more-cc" (click)="toggleRowExpansion()">
                      Show less
                      <span>
                      </span><i class="far fa-chevron-up"></i>
                    </div>
                  </div> -->
                </div>
                <!-- basic infor End -->

                <!-- seasonality -->
                <div *ngIf="section.title === 'Seasonality'">
                  <!-- brand and model line -->
                  <div class="row seasonality-wrapper m-0 mt-3" [ngClass]="{ 'not-allowed': isPartsTechItem }">
                    <div class="col-3 seasonality-tab text-center pointer"
                      [ngClass]="{ active: tire.seasonality === 'summer' ,'magic-focus': isMagicFocus }"
                      (click)="isPartsTechItem ? null : handleChange('summer', 'seasonality')">
                      <i class="fas fa-sun fa-fw font-gray-35"></i>
                      <span class="pl-6p">Summer</span>
                    </div>

                    <div class="col-3 seasonality-tab text-center pointer"
                      [ngClass]="{ active: tire.seasonality === 'winter','magic-focus': isMagicFocus }"
                      (click)="isPartsTechItem ? null : handleChange('winter', 'seasonality')">
                      <i class="far fa-snowflake fa-fw font-gray-35"></i>
                      <span class="pl-6p">Winter</span>
                    </div>

                    <div class="col-3 seasonality-tab text-center pointer"
                      [ngClass]="{ active: tire.seasonality === 'all' ,'magic-focus': isMagicFocus}"
                      (click)="isPartsTechItem ? null : handleChange('all', 'seasonality')">
                      <i class="fas fa-cloud-sun fa-fw font-gray-35"></i>
                      <span class="pl-6p">All seasons</span>
                    </div>

                    <div class="col-3 seasonality-tab text-center pointer"
                      [ngClass]="{ active: tire.seasonality === 'allWeather','magic-focus': isMagicFocus }"
                      (click)="isPartsTechItem ? null : handleChange('allWeather', 'seasonality')">
                      <i class="fas fa-cloud-sun-rain fa-fw font-gray-35"></i>
                      <span class="pl-6p">All Weather</span>
                    </div>
                  </div>
                </div>
                <!-- seasonality end -->
                <!-- Pricing -->
                <div *ngIf="section.title === 'Pricing'">
                  <div class="row input-control-container">
                    <div class="col-6 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p">
                        <label for="tire-brand">Cost Type</label>
                        <app-auto-complete name="cost-type" listId="tire-cost-type" field="label" styleClassInput="pl-1"
                          styleClassInputWrapper="" inactiveItemsKey="value" [hasFutureSelectionField]="false"
                          [hasEditableField]="false" scrollHeight="240px" placeholder="Cost Type" id="tire-cost-type"
                          theme="border" [isClearIconVisible]="tireSize?.costType"
                          [value]="tireSize?.costType === 'cost' ? 'Cost': tireSize?.costType === 'avg' ? 'Avg. Cost' : tireSize?.costType === 'latestPo' ? 'Latest PO' : ''"
                          [suggestions]="
                          tireSize?.stocked && !isOpenFromPO && !isOpenFromST && !isOpenFromRO ?
                          defaultCostOptions : costOptions" [fontSize]="14" [isDropdownIconVisible]="true"
                          [disabled]="(isAttributeBasedPricingEnable && !isPricingManagementEnable)"
                          (appFocus)="handleFocus('costType')" (appClear)="handleClearCostType('costType',$event)"
                          [listItemFontSize]="14" (appBlur)="handleBlur('costType')"
                          (appSelect)="handleSizeChange('costType',$event)">
                        </app-auto-complete>

                      </div>
                    </div>
                    <div class="col-6 flex-start-center input-col"
                      [ngClass]="{ 'magic-focus':(tireSize.cost && isMagicFocus && ( isUseOnlinePricing || isFocusPartTire))}">
                      <div class="width-100p">
                        <label for="tire-size">
                          Cost*
                          <i *ngIf="tireSize?.isUsingFixedCost" class="fal fa-info-circle font-red-800 pointer"
                            tooltipStyleClass="tooltip-width-350" tooltipPosition="top"
                            pTooltip="The cost field shows the fixed cost. Once PO is delivered, the cost will automatically update to {{tireSize?.costType === 'cost' ? 'Cost': tireSize?.costType === 'avg' ? 'Avg. Cost' : 'Latest PO'}}"></i>
                        </label>
                        <app-input id="tire-size" placeholder="Enter cost" [allowDecimal]="focus?.cost ? true: false"
                          [disabled]="(isAttributeBasedPricingEnable && !isPricingManagementEnable) || isPartsTechItem || ((tireSize?.costType === 'avg' || tireSize?.costType === 'latestPo') && tireSize?.stocked)"
                          theme="border" [isInvalid]="errors?.cost" [errorMessage]="errors?.cost"
                          [value]="focus?.cost ? tireSize.cost : (tireSize.cost || 0 | currency: usd)"
                          [autoFocus]="false" (appFocus)="handleFocus('cost')" (appBlur)="handleBlur('cost')"
                          (appChange)="handleSizeChange('cost',$event)">
                        </app-input>
                      </div>
                    </div>
                  </div>
                  <div class="row input-control-container">
                    <div class="col-6 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p">
                        <label for="tire-size">
                          {{isAttributeBasedPricingEnable ? 'Pricing rules' : 'Pricing matrix'}}
                        </label>
                        <div class="position-relative" [ngClass]="{ 'disabled-autocomplete': !isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable),
                                              }" tooltipPosition="top" [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement &&
                                                 (isNewItemCategoriesEnable || isAttributeBasedPricingEnable))  ?
                                                 'Please contact admin / store manager to update' : ''">
                          <app-auto-complete id="tire-pricing" placeholder="Select pricing" label="Select pricing"
                            scrollHeight="198px" editableItemIdKey="_id" [fontSize]="14" theme="border"
                            [value]="tireSize?.pricingMatrix?.name" [listItemFontSize]="14" [isSaveForFuture]="true"
                            [hasFutureSelectionField]="false" [isDropdownIconVisible]="true"
                            (appSelect)="handleSizeChange('pricingMatrix',$event)"
                            [isClearIconVisible]="tireSize?.pricingMatrix?.name"
                            [isDropdownIconVisible]="isAttributeBasedPricingEnable ? false : true"
                            (appCompletedMethod)="handleSearch('pricingMatrix', $event)"
                            [suggestions]="pricingMatrixResults" [disabled]="isAttributeBasedPricingEnable"
                            [confirmClearReq]="true" (appClear)="handleClear('pricingMatrix')">
                            <ng-template let-item let-editItem="editItem" appTemplate="item">
                              <div class="tag-item flex-between-center">
                                <div>
                                  <span>{{ item?.name }}</span>
                                </div>
                              </div>
                            </ng-template>
                          </app-auto-complete>

                          <i *ngIf="isAttributeBasedPricingEnable" class="fal fa-info-circle pricing-rule-click"
                            (click)="openMatrixModal(tireSize?.pricingMatrix)"></i>
                        </div>
                      </div>

                    </div>
                    <div class="col-6 flex-start-center input-col"
                      [ngClass]="{ 'magic-focus': (tireSize.price && isMagicFocus && (isUseOnlinePricing || isFocusPartTire))}">

                      <div class="width-100p">
                        <label for="tire-size">
                          {{isManuallyAdded() ? 'Price (added manually)*' : 'Price (calculated)*'}}
                        </label>
                        <div tooltipPosition="top" [pTooltip]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement &&
                        (isNewItemCategoriesEnable || isAttributeBasedPricingEnable))  ?
                        'Please contact admin / store manager to update' : ''">
                          <app-input id="tire-size" placeholder="Enter price" [disabled]="isPartsTechItem"
                            theme="border" [isInvalid]="errors?.price" [errorMessage]="errors?.price"
                            [allowDecimal]="focus?.price ? true: false"
                            [disabled]="(!isOpenFromRO && isPricingManagementEnable && !isPricingMatricesManagement && (isNewItemCategoriesEnable || isAttributeBasedPricingEnable)) "
                            [value]="focus?.price ? tireSize.price : (tireSize.price || 0 | currency: usd)"
                            [autoFocus]="false" (appFocus)="handleFocus('price')" (appBlur)="handleBlur('price')"
                            (appChange)="handleSizeChange('price',$event)">
                          </app-input>
                        </div>
                      </div>


                    </div>
                  </div>

                  <div class="row input-control-container">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <label for="tire-size">Repair Order Default Quantity* </label>
                        <app-input placeholder="Enter Default Quantity" [disabled]="isPartsTechItem" theme="border"
                          [allowDecimal]="focus?.count ? true: false" [isInvalid]="errors?.count"
                          [errorMessage]="errors?.count"
                          [value]="focus?.count ? tireSize.count : (tireSize.count || 0 | number: '1.2-2')"
                          [selectTextOnFocus]="true" (appChange)="handleSizeChange('count',$event)"
                          (appFocus)="handleFocus('count')" (appBlur)="handleBlur('count')">
                        </app-input>
                      </div>
                    </div>
                    <div class="col-6 flex-start-center input-col" *ngIf="isPassThroughTaxEnable">
                      <div class="width-100p">
                        <label for="tire-size">Federal Excise Tax (FET) Rate </label>
                        <app-input placeholder="Enter FET rate" theme="border" mask="0*.99"
                          [allowDecimal]="focus?.fetValue ? true: false" [isInvalid]="errors?.fetValue"
                          [tooltipIconClass]="isTireConnectConnected ? showLoaderTireconnect ? 'far fa-spinner rotate'
                          : 'far fa-redo pointer right-icon-sec '+ getIconColor() : ''" tooltipIconPosition="top"
                          tooltipStyleClass="fet-tooltip-tireconnect"
                          [disabled]="!(tireId || (serviceItem && serviceItem.itemId)) && isOpenFromRO"
                          [pTooltip]="!(tireId || (serviceItem && serviceItem.itemId)) && isOpenFromRO ? 'Fee association not allowed when creating item from RO' : ''"
                          [tooltipIconText]="isTireConnectConnected ? 'Get FET rate from TireConnect' : ''"
                          [value]="focus?.fetValue ? tire?.fet || tireSize?.fetValue : (tire?.fet || tireSize?.fetValue || 0 | currency: usd)"
                          [selectTextOnFocus]="true" (appChange)="handleSizeChange('fetValue',$event)"
                          (appFocus)="handleFocus('fetValue')" (appBlur)="handleBlur('fetValue')"
                          (onTooltipIconClicked)="isTireConnectConnected && !showLoaderTireconnect ? getFETRatefromTireConnect() : ''">
                        </app-input>
                      </div>
                    </div>
                  </div>

                  <div class="mt-2 row input-control-container" *ngIf="isFeeAssociationEnabled">
                    <div class="col-12 flex-start-center input-col">
                      <div class="width-100p">
                        <label for="tire-brand">Associated Fee</label>
                      </div>
                    </div>

                    <div class="col-12 flex-start-center input-col mb-2"
                      *ngFor="let hazmatFee of tireSize?.hazmatFeeArray; let i = index">

                      <div class="col-6 flex-start-center input-col pl-0">
                        <div class="width-100p">
                          <app-auto-complete id="tire-supplier" listId="tire-supplier-list" placeholder="Search Fee"
                            label="Supplier" scrollHeight="198px" editFieldPlaceholder="Create supplier" theme="border"
                            [fontSize]="14" [hasFutureSelectionField]="false"
                            [disabled]="!(tireId || (serviceItem && serviceItem.itemId)) || isOpenFromRO"
                            [pTooltip]="!(tireId || (serviceItem && serviceItem.itemId)) || isOpenFromRO ? 'Fee association not allowed when creating item from RO' : ''"
                            [closeOnSelection]="true" [suggestions]="itemResults[i]" (appSelect)="onROSelect($event, i)"
                            (appCompletedMethod)="searchSuggestion($event, i)" [isLoading]="isSearching"
                            [value]="helperService.getLocalizationValue(currentLang, hazmatFee, 'title')"
                            [listItemFontSize]="14">
                            <ng-template let-item let-query="query" appTemplate="item">
                              <div class="fee-search-item flex-start-center width-100p">
                                <i class="fal far fa-usd-circle font-gray-75 p-2"></i>
                                <div class="flex-start-center width-100p">
                                  <div class="flex-column width-100p">
                                    <div class="search-item-header flex-between-center width-100p">
                                      <div class="search-title-wrapper">
                                        <p class="m-0 text-truncate search-title">{{
                                          helperService.getLocalizationValue(currentLang, item, 'title') }}</p>
                                        <p class="m-0 text-truncate font-11 font-gray-55 search-description width-100p">
                                          {{ helperService.getLocalizationValue(currentLang, item, 'description', true)
                                          || 'No description' }}
                                        </p>
                                      </div>

                                      <div class="m-0 text-truncate search-price-cost width-100p text-right">
                                        <p class="search-price m-0 font-600">Price: {{ item.price || 0 | currency:
                                          usd
                                          }}</p>
                                        <p class="search-cost m-0">Cost: {{ item.cost || 0 | currency: usd }}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </app-auto-complete>
                        </div>
                      </div>
                      <div class="col-6 flex-start-center input-col">
                        <span
                          *ngIf="hazmatFee?.feeValueType && hazmatFee?.feeValueType === 'percent'; else typeFixedTemplate">
                          Total fee will be equal to {{ (hazmatFee?.price / 100) * tireSize.price || 0 |
                          currency:
                          usd
                          }}
                          per unit of the
                          item ({{ hazmatFee?.price }}% * {{ tireSize.price || 0 | currency: usd }})
                        </span>

                        <ng-template #typeFixedTemplate>
                          <span>Total fee will be equal to {{ hazmatFee?.price || 0 | currency: usd }} per unit of
                            the
                            item</span>
                        </ng-template>

                        <button class="del-btn" (click)="removeHazmatFee({ feeIndex: i })" *ngIf="hazmatFee?._id && !isOpenFromRO">
                          <i class="fal fa-trash"></i>
                        </button>
                      </div>
                    </div>

                    <div class="col-12 flex-start-center input-col mt-2" *ngIf="!isOpenFromRO">
                      <div class="width-100p">
                        <button [disabled]="!(tireId || (serviceItem && serviceItem.itemId))"
                          [pTooltip]="!(tireId || (serviceItem && serviceItem.itemId)) && isOpenFromRO ? 'Fee association not allowed when creating item from RO' : ''"
                          class="btn add-fee-btn" (click)="addAnotherFee()">
                          <i class="fal fa-plus-circle fa-fw"></i>
                          {{tireSize?.hazmatFeeArray?.length > 0 ? 'Add another fees':'Add another fee'}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Pricing Ends -->
                </div>

                <!-- Part Classification -->
                <div *ngIf="section.title === 'Part Classification'">
                  <div class="part-classification-wrapper">
                    <div class="row mt-4 mb-4 align-items-center">
                      <div class="col-2">
                        Tire Category
                      </div>
                      <div class="col-6" [ngClass]="{ 'magic-focus': isMagicFocus }">
                        <div>
                          <div *ngIf="isNewCategoriesEnabled" tooltipPosition="top"
                            tooltipStyleClass="tooltip-width-medium text-center"
                            [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''">

                            <app-auto-complete id="standard-category" listId="standard-category-list"
                              field="categoryName" label="tire Category" placeholder="Select tire category"
                              scrollHeight="186px" theme="border"
                              [value]="tire?.category?.categoryName || tire?.category?.name" [fontSize]="14"
                              [disabled]="!canEditClassifications" [listItemFontSize]="14"
                              [isLoading]="loader?.category" [suggestions]="categoryResults"
                              [isClearIconVisible]="tire?.category?.categoryName" [isDropdownIconVisible]="true"
                              (appChange)="handleChangeCategory('tire', $event)" (appBlur)="handleBlur('category')"
                              (appFocus)="showSuggestions('tags')" (appSelect)="handleSelect($event, 'category')"
                              (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                              (appClear)="onClearSuggestion('category')"></app-auto-complete>
                          </div>

                          <!-- Categories -->
                          <div *ngIf="!isNewCategoriesEnabled">
                            <app-auto-complete placeholder="Select tire category" field="categoryName"
                              scrollHeight="198px" theme="border" editableItemIdKey="_id"
                              editFieldLabel="Create Category" [hasEditableField]="true" [isShowError]="isShowError"
                              [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
                              [hasStaticUnassignedFiled]="false" [suggestions]="categoryResults" [listItemFontSize]="14"
                              [fontSize]="14" [value]="tire?.category?.categoryName || tire?.category?.name"
                              [isClearIconVisible]="tire?.category?.categoryName  || tire?.category?.name"
                              (appFocus)="showSuggestions('tags')" (appBlur)="handleBlur('category')"
                              (appUpdateItem)="onUpdateItem($event, categoryType)"
                              (appSelect)="handleSelect($event, 'category')" (appSave)="saveCategory($event)"
                              (appChange)="handleChangeCategory('tire', $event)"
                              (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                              (appClear)="onClearSuggestion('tags')">
                              <ng-template let-item let-editItem="editItem" appTemplate="item">
                                <div class="tag-item flex-between-center">
                                  <div>
                                    <span>{{ item?.categoryName }}</span>
                                  </div>
                                  <div class="tag-item-action flex-end-center">
                                    <i class="fas fa-pencil p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                                      (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return : editItem(item)"></i>
                                    <i class="fa fa-trash p-1 mr-2" [hidden]="item?.nameSort === 'unassigned'"
                                      (click)="$event.stopPropagation(); item?.nameSort === 'unassigned' ? return  : deleteCategoryDialog(item)"></i>
                                  </div>
                                </div>
                              </ng-template>
                            </app-auto-complete>
                          </div>
                        </div>
                      </div>
                      <div class="col-1"></div>
                    </div>

                    <!-- Tire Type -->
                    <div class="row mb-4 align-items-center">
                      <div class="col-2">
                        Tire Type
                      </div>
                      <div class="col-6" [ngClass]="{ 'magic-focus': isMagicFocus }">
                        <app-auto-complete id="tire-type" listId="tire-type-list" placeholder="Select tire type"
                          label="Tire type" scrollHeight="198px" theme="border" [fontSize]="14"
                          [hasFutureSelectionField]="false" [value]="tire?.tireType?.name" [listItemFontSize]="14"
                          [isDropdownIconVisible]="true" [suggestions]="tireTypeSuggestion" [hasEditableField]="false"
                          [isClearIconVisible]="tire?.tireType?.name"
                          (appCompletedMethod)="handleTireTypeSearch($event)" (appClear)="handleClear('tireType')"
                          (appSelect)="handleSelect($event, 'tireType')">
                        </app-auto-complete>
                      </div>
                    </div>

                    <!-- <div class="row mb-4 align-items-center" [hidden]="openFrom === 'inventoryAdd'">
                      <div class="col-2">
                        Location
                      </div>
                      <div class="col-6">
                        <app-auto-complete id="tire-locations-{{index}}" listId="tire-locations-list-{{index}}"
                          placeholder="Select location" [disabled]="isLocationDisabled()" scrollHeight="186px"
                          theme="border" name="itemRef" [isInvalid]="errors?.location" [errorMessage]="errors?.location"
                          styleClassInputWrapper="pl-1" styleClassInput="pl-1" field="name"
                          [isSetPositionDynamically]="true" [value]="tireSize?.location?.name" [fontSize]="14"
                          [listItemFontSize]="14" [suggestions]="locationsResults"
                          [isClearIconVisible]="tireSize?.location?.name" [isDropdownIconVisible]="true"
                          (appFocus)="handleFocus('location')" (appBlur)="handleBlur('location')"
                          (appSelect)="handleSizeChange('location',$event)" (appCompletedMethod)="search($event)"
                          (appClear)="handleClear('location')">
                          <ng-template let-item let-editItem="editItem" appTemplate="item">
                            <div class="tag-item flex-between-center">
                              <span class="font-14">{{ item?.name }}</span>
                            </div>
                          </ng-template>
                        </app-auto-complete>
                      </div>
                    </div> -->

                    <!-- Sale code -->
                    <div class="row align-items-center" *ngIf="isNewCategoriesEnabled && isSalesCodeEnabled">
                      <div class="col-2">
                        Sales Code
                      </div>
                      <div class="col-6">
                        <div class="sales-code-tag-wrapper">
                          <!-- <div class="sales-code-tags">
                            {{displaySalesCodeTitle() || 'Unassigned'}}
                          </div> -->
                          <div *ngIf="tire?.salesCode?.title" class="badge-text flex-start-center" tooltipPosition="top"
                            tooltipStyleClass="tooltip-width-medium text-center"
                            [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : ''">
                            {{tire?.salesCode?.title}}&nbsp;({{tire?.salesCode?.shortName}})
                            <img src="assets/img/icon/edit-outline.svg" class="pointer"
                              (click)="openAssignSalesCodeDialog()" />
                          </div>
                          <div *ngIf="!tire?.salesCode?.title" class="badge-text warning pointer" tooltipPosition="top"
                            tooltipStyleClass="tooltip-width-medium text-center"
                            [pTooltip]="!canEditClassifications && !isOpenFromRO ? classificationPrivilegeMsg : ''"
                            (click)="openAssignSalesCodeDialog()">
                            Assign
                            <i class="far fa-plus"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Part Classification End-->

                <div *ngIf="section?.title === 'Tire Warranty' && isPartWarrantiesEnabled">
                  <div class="row h-auto">
                    <!-- Tire warranty eligible section -->
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p pl-1 pr-2">
                        <app-switch-pill id="tire-warranty" label="Warranty Eligible" position="end"
                          [disabled]="!tire?.tireType?.tireTypeId" styleClassLabel="font-gray-35" [fontSize]="12"
                          [isActive]="tire?.isWarrantyEligible" (appChange)="handleChange($event,'isWarrantyEligible')">
                        </app-switch-pill>
                      </div>
                    </div>
                    <!-- Warranty view section -->
                    <div class="col-6 flex-end-center input-col">
                      <button class="btn btn-unassigned-light font-14 font-700">
                        {{tire?.isWarrantyEligible && tire?.warranty?.warrantySettingId ? tire?.warranty?.title :
                        'Unassigned'}}
                        <i class="fa fa-spinner rotate ml-1" *ngIf="isFetchingWarranty"></i>
                      </button>
                      <div class="pointer font-12 font-700 ml-3" (click)="navigateToWarrantySection()">
                        <i class="far fa-external-link-alt font-primary"></i>
                        <span class="font-primary pl-2">View Warranty Settings</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!--******* Inventory Details ******-->
                <!-- part?.stocked{{part?.stocked}} isOpenFromRO{{isOpenFromRO}} -->
                <div
                  *ngIf="section?.title === 'Inventory Details' && isInventoryEnabled &&  (tireSize?.stocked || tireSize?.hasMarkedInventory || !isOpenFromRO)">
                  <div class="row h-auto">
                    <div class="col-4 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill label="Mark as inventory" position="end" styleClassLabel="font-gray-35"
                          (appChange)="handleChange($event, 'hasMarkedInventory')" [disabled]="tire?.stocked"
                          [isActive]="tireSize?.hasMarkedInventory || tire?.stocked" [fontSize]="12">
                        </app-switch-pill>
                      </div>
                    </div>
                    <div class="col-8 flex-end-start input-col" *ngIf="(tireSize?.hasMarkedInventory ||
                    tireSize?.stocked) && isInventoryEnabled">
                      <div class="ml-auto">
                        <div *ngIf="tireSize?.stocked" class="ui-g-12 flex-end-start ml-4" style="min-height: 40px;"
                          (click)="graphdata(tireSize.tireID, 'tire')">
                          <div class="icon flex-center-start part-sales-trends">
                            <app-history-inv-sales-chart [type]="'tire'" [itemId]="tireSize?.tireID"
                              label="Historical sales/reorder trend">
                            </app-history-inv-sales-chart>
                            <div (click)="openQtyOnEstimateModal()" class="d-flex m-left-35 pointer">
                              <i class="far fa-calendar-check font-primary align-self-center"></i>
                              <p class="mb-0 font-bold font-14 font-primary pl-2">Qty on estimates detail</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex align-items-center p-0" *ngIf="(tireSize?.hasMarkedInventory ||
                  tireSize?.stocked) && isInventoryEnabled">
                    <div class="d-flex inventory-details-wrapper">
                      <div class="d-flex font-12 align-items-center">
                        <i class="far fa-boxes height-icon"></i>
                        <span class="px-2 align-self-center">Available</span>
                        <span class="font-bold align-self-center">
                          {{tireSize?.qtyAvailable | number: '1.2-2'}}
                        </span>
                      </div>

                      <div class="px-5 align-self-center">
                        <i class="fal fa-equals fa-fw font-24"></i>
                      </div>

                      <div class="d-flex font-12">
                        <span class="pr-2 align-self-center">On hand</span>
                        <span class="font-bold align-self-center">
                          {{tireSize.qtyOnHand | number: '1.2-2'}}
                        </span>
                      </div>

                      <div class="align-self-center px-5">
                        <i class="fal fa-minus fa-fw font-24"></i>
                      </div>

                      <div class="d-flex font-12">
                        <span class="pr-2 align-self-center">On Estimates</span>
                        <span class="font-bold align-self-center">
                          {{tireSize.qtyOnOrder | number: '1.2-2'}}
                        </span>
                      </div>
                    </div>

                    <div class="d-flex mx-3 font-12 inventory-details-wrapper align-items-center">
                      <i class="far fa-truck height-icon"></i>
                      <span class="px-2 align-self-center">Ordered</span>
                      <span class="font-bold align-self-center">
                        {{tireSize.qtyOrdered | number: '1.2-2'}}
                      </span>
                    </div>
                  </div>

                  <div class="row input-control-container" *ngIf="(tireSize?.hasMarkedInventory ||
                  tireSize?.stocked) && isInventoryEnabled">
                    <div class="col-6 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p">
                        <label for="tire-brand">Supplier</label>
                        <app-auto-complete id="tire-supplier" listId="tire-supplier-list" placeholder="Select supplier"
                          label="Supplier" scrollHeight="198px" editFieldLabel="Create supplier"
                          editFieldPlaceholder="Create supplier" theme="border" [disabled]="isPartsTechItem"
                          [fontSize]="14" [isSaveForFuture]="true" [hasFutureSelectionField]="false"
                          [value]="tire?.vendor?.name" [listItemFontSize]="14" [isDropdownIconVisible]="true"
                          [suggestions]="vendorsSuggestion" [hasEditableField]="true"
                          [isClearIconVisible]="tire?.vendor?.name" (appCompletedMethod)="handleVendorSearch($event)"
                          (appClear)="handleClear('vendor')" (appSelect)="handleSelect($event, 'vendor')"
                          (appSave)="handleCreateSupplier($event)">
                          <ng-template let-item let-editItem="editItem" appTemplate="item">
                            <div class="tag-item flex-between-center">
                              <div>
                                <span>{{ item?.name }}</span>
                              </div>
                              <div class="tag-item-action flex-end-center">
                                <i class="fas fa-pencil p-1 mr-2"
                                  (click)="$event.stopPropagation(); editItem(item)"></i>
                              </div>
                            </div>
                          </ng-template>
                        </app-auto-complete>
                      </div>

                    </div>
                  </div>

                  <div class="row input-control-container" *ngIf="(tireSize?.hasMarkedInventory ||
                  tireSize?.stocked) && isInventoryEnabled">
                    <div class="col-6 flex-start-center input-col">

                      <div class="width-100p">
                        <label for="tire-size">Minimum Quantity Level</label>
                        <app-input class="error" id="tire-qty-on-restock-" type="text"
                          [allowDecimal]="focus?.restockLevel ? true: false"
                          placeholder="Enter minimum quantity level / reorder level" theme="border" [fontSize]="14"
                          [errorMessage]="errors?.restockLevel" [isInvalid]="errors?.restockLevel"
                          [value]="focus?.restockLevel ? tireSize.restockLevel : (tireSize.restockLevel | number: '1.2-2')"
                          (appChange)="handleSizeChange('restockLevel',$event)" (appFocus)="handleFocus('restockLevel')"
                          (appBlur)="handleBlur('restockLevel')">
                        </app-input>
                      </div>


                    </div>
                    <div class="col-6 flex-start-center input-col">

                      <div class="width-100p">
                        <label for="tire-size">Maximum Quantity Level</label>
                        <app-input id="tire-qty-on-maxQuantity" type="text"
                          [allowDecimal]="focus?.maxQuantity ? true : false" placeholder="Enter maximum quantity level"
                          theme="border" [fontSize]="14"
                          [value]="focus?.maxQuantity ? tireSize.maxQuantity : (tireSize.maxQuantity | number: '1.2-2')"
                          (appChange)="handleSizeChange('maxQuantity',$event)" (appFocus)="handleFocus('maxQuantity')"
                          (appBlur)="handleBlur('maxQuantity')">
                        </app-input>
                      </div>
                    </div>
                  </div>

                  <div class="row input-control-container" *ngIf="(tireSize?.hasMarkedInventory ||
                  tireSize?.stocked) && isInventoryEnabled">
                    <div class="col-12 flex-start-center input-col">
                      <div class="width-100p">
                        <label for="tire-brand">Location</label>
                        <app-auto-complete id="tire-locations-{{index}}" listId="tire-locations-list-{{index}}"
                          placeholder="Select location" [disabled]="isLocationDisabled()" scrollHeight="186px"
                          theme="border" name="itemRef" [isInvalid]="errors?.location" [errorMessage]="errors?.location"
                          styleClassInputWrapper="pl-1" styleClassInput="pl-1" field="name"
                          [isSetPositionDynamically]="true" [value]="tireSize?.location?.name" [fontSize]="14"
                          [listItemFontSize]="14" [suggestions]="locationsResults"
                          [isClearIconVisible]="tireSize?.location?.name" [isDropdownIconVisible]="true"
                          (appFocus)="handleFocus('location')" (appBlur)="handleBlur('location')"
                          (appSelect)="handleSizeChange('location',$event)" (appCompletedMethod)="search($event)"
                          (appClear)="handleClear('location')">
                          <ng-template let-item let-editItem="editItem" appTemplate="item">
                            <div class="tag-item flex-between-center">
                              <span class="font-14">{{ item?.name }}</span>
                            </div>
                          </ng-template>
                        </app-auto-complete>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 input-control-container" *ngIf="isMultiLocationEnabled && isStockTransferEnabled">
                    <div class="d-flex ui-g-3 flex-between-center font-12 inventory-details-wrapper pointer"
                      [pTooltip]="tireSize?.otherLocationDataTooltip" tooltipPosition="bottom"
                      tooltipStyleClass="ml-transferorder-tooltip" [escape]="false">
                      <div class="flex-row">
                        <i class="far fa-boxes height-icon"></i>
                        <span class="px-2 align-self-center">Available (other)</span>
                      </div>
                      <span class="font-bold align-self-center">{{ tireSize?.otherLocationQty || 0 | number: '1.2-2'
                        }}</span>
                    </div>

                    <div class="d-flex ui-g-2 font-12 pointer flex-around-center pt-1">
                      <app-dropdown id="d-action-transfer" listId="d-action-list-transfer" field="label"
                        itemWidth="200px" scrollHeight="200px" [options]="transferOptions"
                        [isDropdownIconVisible]="false" [hasCustomOpenTemplate]="true" [selectInactiveItems]="false"
                        [hasCustomItemTemplate]="true" [isCustomizedTemplate]="true" [disabled]="false"
                        (appSelect)="handleTransferSelect($event)">
                        <ng-template let-item appTemplate="open-dropdown-btn">
                          <span class="font-12 font-600 font-primary"> <i class="fas fa-exchange pr-2"></i> Transfer
                          </span>
                        </ng-template>

                        <ng-template let-item appTemplate="item">
                          <div class="width-100p flex-between-center">
                            <span class="font-14 font-600">{{ item?.label }}</span>
                          </div>
                        </ng-template>
                      </app-dropdown>
                    </div>
                  </div>
                </div>
                <!--*******Inventory Details Ends ******-->

                <!-- Tire Settings -->
                <div *ngIf="section.title === 'Tire Settings'">
                  <div class="row mt-3 h-auto mb-3">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill label="Taxable" position="end" styleClassLabel="font-gray-35" [fontSize]="12"
                          [isActive]="tireSize?.isTaxable" (appChange)="handleSizeChange('isTaxable',$event)">
                        </app-switch-pill>
                      </div>

                    </div>
                  </div>
                  <div class="row h-auto mb-3">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill [label]="tireSize.status ? 'Active' : 'Inactive'" position="end"
                          styleClassLabel="font-gray-35" [fontSize]="12"
                          [disabled]="!!orderServiceId && !updateGenericItem" [isActive]="tireSize?.status"
                          (appChange)="handleSizeChange('status',$event)">
                        </app-switch-pill>
                      </div>

                    </div>
                  </div>
                  <div class="row h-auto mb-3">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill label="Commissionable" position="end" styleClassLabel="font-gray-35"
                          [isActive]="tireSize?.commissionable" [fontSize]="12"
                          (appChange)="handleSizeChange('commissionable',$event)">
                        </app-switch-pill>
                      </div>

                    </div>
                  </div>
                  <div class="row h-auto mb-3">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill label="Display Part Description on estimate and invoice" position="end"
                          [isActive]="tireSize?.displayDescOnOrder"
                          (appChange)="handleSizeChange('displayDescOnOrder',$event)" styleClassLabel="font-gray-35"
                          [fontSize]="12">
                        </app-switch-pill>
                      </div>

                    </div>
                  </div>
                  <div class="row h-auto mb-3">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <app-switch-pill label="Display Quantity and Price on estimate and invoice" position="end"
                          [isActive]="tireSize?.displayHoursOnOrder"
                          (appChange)="handleSizeChange('displayHoursOnOrder',$event)" styleClassLabel="font-gray-35"
                          [fontSize]="12">
                        </app-switch-pill>
                      </div>
                    </div>
                  </div>

                  <div class="row h-auto mb-3" *ngIf="isQboConnected">
                    <div class="col-6 flex-start-center input-col">
                      <div class="width-100p">
                        <label for="tire-brand">QBO item reference</label>
                        <app-auto-complete placeholder="QBO item reference" theme="border" scrollHeight="165px"
                          name="itemRef" field="title" [value]="tireSize?.qboItemRef?.title" [suggestions]="qboItemRefs"
                          [isDropdownIconVisible]="true" [fontSize]="14" [listItemFontSize]="14"
                          [isClearIconVisible]="tireSize?.qboItemRef?.title"
                          (appSelect)="handleSizeChange('qboItemRef',$event)"
                          (appCompletedMethod)="onSearchItem($event)" (appClear)="handleClear('qboItemRef')">
                        </app-auto-complete>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Tire Settings Ends -->

                <!-- Additional Details -->
                <div *ngIf="section.title === 'Additional Details'">
                  <div class="row input-control-container" *ngIf="!companyLocalization else localizationFlagDesc">
                    <div class="col-12 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p">
                        <label for="tire-brand">Part Description</label>
                        <div class="width-100p">
                          <app-textarea placeholder="Enter part description" theme="border" [maxLength]="10000"
                            textAreaId="tie-save-dialog" [autoGrow]="true" [maxAutoGrowHeight]="64" [rows]="1"
                            [value]="tireSize?.description" [rows]="1"
                            (appChange)="handleSizeChange('description',$event)" (appFocus)="handleFocus('description')"
                            (appBlur)="handleBlur('description')">
                          </app-textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #localizationFlagDesc>
                    <div class="d-flex"
                      [ngClass]="{'flex-column-reverse': currentLang === 'fr', 'flex-column': currentLang !== 'fr'}">
                      <div class="row input-control-container">
                        <div class="col-12 flex-start-center input-col">
                          <!-- brand -->
                          <div class="width-100p">
                            <label for="tire-brand">Part Description (EN)</label>
                            <div class="width-100p">
                              <app-textarea placeholder="Enter part description" theme="border" [maxLength]="10000"
                                textAreaId="tie-save-dialog" [autoGrow]="true" [maxAutoGrowHeight]="64" [rows]="1"
                                [value]="tireSize?.description" [rows]="1"
                                (appChange)="handleSizeChange('description',$event)"
                                (appFocus)="handleFocus('description')" (appBlur)="handleBlur('description')">
                              </app-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row input-control-container">
                        <div class="col-12 flex-start-center input-col">
                          <!-- brand -->
                          <div class="width-100p">
                            <label for="tire-brand">Part Description (FR)</label>
                            <div class="width-100p">
                              <app-textarea placeholder="Enter part description" theme="border" [maxLength]="10000"
                                textAreaId="tie-save-dialog" [autoGrow]="true" [maxAutoGrowHeight]="64" [rows]="1"
                                [value]="tireSize?.descriptionFR" [rows]="1"
                                (appChange)="handleSizeChange('descriptionFR',$event)"
                                (appFocus)="handleFocus('descriptionFR')" (appBlur)="handleBlur('descriptionFR')">
                              </app-textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>

                  <div class="row input-control-container">
                    <div class="col-12 flex-start-center input-col">
                      <!-- brand -->
                      <div class="width-100p">
                        <label for="tire-brand">Internal Notes</label>
                        <div class="width-100p">
                          <app-textarea placeholder="Enter internal notes" theme="border" id="internal-tire-desc"
                            textAreaId="internal-tire-desc-textarea" [autoGrow]="true" [maxAutoGrowHeight]="64"
                            [rows]="1" [value]="tireSize?.internalNotes" [rows]="1"
                            (appChange)="handleSizeChange('internalNotes',$event)"
                            (appFocus)="handleFocus('internalNotes')" (appBlur)="handleBlur('internalNotes')">
                          </app-textarea>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- Additional Details Ends -->

              </div>
            </div>
            <div class="scroll-wrapper-inner" [hidden]="selectedTab === 0">
              <div class="sections-wrapper">
                <h3>Activity logs</h3>
                <div class="activity-logs">
                  <div class="catalog-activity-wrapper">
                    <!-- Activity logs -->
                    <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
                      <div *ngFor="let activityLog of activityLogs">
                        <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
                      </div>
                    </div>

                    <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
                      <p>There are no activity logs.</p>
                    </div>

                    <!-- Filter wrapper -->
                    <div class="filter-ddl-wrapper">
                      <div class="dropdown">
                        <div class="btn dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown"
                          aria-haspopup="true" aria-expanded="false">
                          Filter &nbsp;
                          <i *ngIf="isFilterLoading" class="fal fa-spinner rotate"></i>
                          <span *ngIf="filterOption?.length" class="filter-count-bubble">{{
                            selectedFilterOptionLength
                            }}</span>
                        </div>

                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                          <ul class="catalog-list-filter">
                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                              <app-checkbox label="Item history" [isChecked]="filterOptionModel.itemHistory"
                                [fontSize]="12" (appChange)="onCheckboxChange($event, 'catalog-item')">
                              </app-checkbox>
                            </li>
                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                              <app-checkbox label="Pricing history" [isChecked]="filterOptionModel.pricingHistory"
                                [fontSize]="12" (appChange)="onCheckboxChange($event, 'item-pricing')">
                              </app-checkbox>
                            </li>
                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                              <app-checkbox label="Purchase history" [isChecked]="filterOptionModel.purchaseHistory"
                                [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-purchase-history-po')">
                              </app-checkbox>
                            </li>
                            <li class="catalog-list-filter-items" (click)="$event.stopPropagation()">
                              <app-checkbox label="Selling history" [isChecked]="filterOptionModel.sellingHistory"
                                [fontSize]="12" (appChange)="onCheckboxChange($event, 'ci-sale-history-ro')">
                              </app-checkbox>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- Start Add Tire Body ends -->

      <!-- Start Add Parts Footer -->
      <div class="ui-g-12 flex-between-center dialog-footer part-footer">
        <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
          <div>
            <app-checkbox *ngIf="isAutoLeapItem && (orderServiceId || isOpenFromPO) && tireId && !isOpenFromMO"
              inputId="cb-part-add-another" label="Also update tire across application" [isChecked]="updateGenericItem"
              [disabled]="isPricingManagementEnable && !isPricingMatricesManagement && (tire?.isChangeInPriceMatrix || isChangeInPriceMatrix)"
              tooltipPosition="top" tooltipStyleClass="tooltip-width-200"
              [pTooltip]="isPricingManagementEnable && !isPricingMatricesManagement && (tire?.isChangeInPriceMatrix || isChangeInPriceMatrix) ? 'Current pricing is different from default. Please contact admin / store manager to update' : ''"
              (appChange)="updateGenericItem = $event; tire.sizes[0].status = defaultActiveState">
            </app-checkbox>
            <span *ngIf="isOpenFromMO" class="width-100p">
              You can only update tire location from this modal
            </span>
          </div>

          <div>
            <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
            <button class="btn btn-primary btn-submit" tooltipPosition="top"
              [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : (isAssigningFET ? 'Assigning FET (Federal Excise Tax)': '')"
              [disabled]="isProcessing || isFinalizedRo || isLockedRO || isAssigningFET" (click)="handleSubmit()">
              <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
              <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- End Add Parts Footer -->
    </div>
  </div>
